import { Component, OnInit, ChangeDetectorRef, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';

import { InstallationExecutiveSummaryPluginService } from './executivesummary-plugin.service';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'installationexecutivesummary-edit',
    templateUrl: './executivesummary-edit.component.html',
    standalone: false
})
export class InstallationExecutiveSummaryEditPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  plugin: any;
  editForm: UntypedFormGroup;
  private sub = new Subscription();

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    protected pluginService: InstallationExecutiveSummaryPluginService,
    location: Location,
    protected cdRef: ChangeDetectorRef
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  save(model: any) {
    this.processing = true;
    this.pluginService.updateExecutiveSummary(this.inspectionId, this.pluginId, model.value).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  cancel() {
    this.goToBack();
  }

  initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  initForm() {
    this.editForm = new UntypedFormGroup({
      value: new UntypedFormControl(this.plugin.config.Value, Validators.required)
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
